module.exports = __webpack_public_path__ + "img/august-green.82a0c6f8.svg";